import UserService from 'Services/user';
import BillingFields from 'Components/billing-fields';

export default {
	name: 'account-billing-modal',
	components: {
		BillingFields
	},
	created() {
		this.vue = this;
		this.billingAddress.firstname = this.$route.params.credential.firstname;
		this.billingAddress.lastname = this.$route.params.credential.lastname;
		this.billingAddress.countrycode = this.$route.params.credential.countrycode;
		this.billingAddress.address = this.$route.params.credential.address;
		this.billingAddress.city = this.$route.params.credential.city;
		this.billingAddress.zip = this.$route.params.credential.zip;
		this.billingAddress.company = this.$route.params.credential.company;
		this.billingAddress.vatnumber = this.$route.params.credential.vatnumber;
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			vue: undefined,
			isLoading: false,
			backed: false,
			isSaving: false,
			tabs: 'individual',
			billingAddress: {
				firstname: '',
				lastname: '',
				countrycode: '',
				address: '',
				city: '',
				zip: '',
				company: '',
				vatnumber: ''
			}
		};
	},
	methods: {
		changeBillingAddress() {
			this.$emit('getBillingInfo');
		},
		billingPayload(payload) {
			this.isSaving = true;
			UserService.setBillingAddress(payload)
				.then(response => {
					this.back();
					this.$parent.billingAddressUpdated(payload);
				})
				.catch(error => {
					this.errors.add({
						field: 'apierror',
						msg: 'Unable to update payment method'
					});
				})
				.finally(() => {
					this.isSaving = false;
				});
		},
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.push('/account');
			}
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/account-billing-modal/script.js